import React from "react";

export default function Retailer_terms() {
  return (
    <div
      style={{ marginLeft: "10px" }}
      class="h-min-height-100p h-width-100p b-content-wrapper"
    >
      <div class="container">
        <div class="h-bg-white h-pv-15 h-ph-15 h-mv-20 b-static-page">
          <div class="h-p-20">
            <div class="h-bg-white h-pv-15 h-ph-15">
              <h1 style={{ color: "#FF6A00" }}>TERMS & CONDITIONS</h1>

              <h3 style={{ color: "#FF6A00" }}>1. Introduction</h3>
              <p>
                Welcome to Ant Technology’s B2B E-Commerce Platform (“the
                Platform”), operated by Ant Technology Plc (“Ant”, “we”, “us”,
                or “our”).
              </p>
              <p>
                By registering and using our platform or any related services,
                you (“User”, “you”, or “your”) agree to comply with these Terms
                and Conditions and any related policies.
              </p>
              <p>
                These Terms and Conditions govern all Retailers (registered
                businesses purchasing goods or services from suppliers via the
                platform) using the Ant B2B Platform.
              </p>

              <h3 style={{ color: "#FF6A00" }}>
                2. Eligibility and Account Registration
              </h3>
              <ul>
                <li>
                  Users must be legally registered businesses or licensed
                  service providers in Ethiopia or regions where Ant operates.
                </li>
                <li>
                  Users must provide valid business registration documents, Tax
                  Identification Number (TIN), and accurate contact details.
                </li>
                <li>
                  Users agree to maintain accurate and up-to-date account
                  information.
                </li>
                <li>
                  Ant reserves the right to verify, suspend, or terminate
                  accounts that provide misleading or fraudulent information.
                </li>
              </ul>

              <h3 style={{ color: "#FF6A00" }}>3. Platform Use and Conduct</h3>
              <p>
                All users agree to use the platform lawfully and in good faith.
              </p>
              <ul>
                <li>Engage in illegal, misleading, or unethical activities</li>
                <li>Upload harmful, offensive, or infringing content</li>
                <li>Circumvent payment systems or contractual obligations</li>
                <li>
                  Misuse intellectual property or confidential information
                </li>
              </ul>
              <p>
                Ant reserves the right to monitor activities, investigate
                complaints, and take corrective actions including suspension or
                termination.
              </p>

              <h3 style={{ color: "#FF6A00" }}>4. Retailer Obligations</h3>
              <ul>
                <li>
                  Provide accurate business, contact, and delivery details
                </li>
                <li>Verify product quality and quantity upon delivery</li>
                <li>Report any issues within 48 hours of receiving goods</li>
                <li>
                  Maintain ethical buying behavior and avoid false or misleading
                  orders
                </li>
              </ul>

              <h3 style={{ color: "#FF6A00" }}>5. Orders and Payments</h3>
              <ul>
                <li>
                  Confirmed orders are legally binding agreements between
                  retailers and suppliers
                </li>
                <li>
                  Payments must be made via AntPay, Telebirr, M-Pesa, or other
                  authorized gateways
                </li>
                <li>
                  Payment failure or unjustified reversal may lead to account
                  restriction
                </li>
              </ul>

              <h3 style={{ color: "#FF6A00" }}>6. Returns and Disputes</h3>
              <ul>
                <li>
                  Return or refund requests must be initiated within 48 hours of
                  delivery for defective or incorrect goods
                </li>
                <li>
                  Ant acts as an intermediary; final decisions depend on
                  supplier confirmation and evidence
                </li>
                <li>Refunds are processed via the original payment method</li>
              </ul>

              <h3 style={{ color: "#FF6A00" }}>
                7. Retailer Ratings and Conduct
              </h3>
              <ul>
                <li>
                  Ant may implement rating systems to assess reliability and
                  professionalism
                </li>
                <li>
                  Fraudulent or repeated misuse may result in suspension or
                  termination
                </li>
                <li>
                  Ratings and feedback are used to measure trustworthiness
                </li>
              </ul>

              <h3 style={{ color: "#FF6A00" }}>8. Account Suspension</h3>
              <p>Ant may suspend or terminate accounts due to:</p>
              <ul>
                <li>Payment defaults or persistent delays</li>
                <li>False dispute claims</li>
                <li>Platform misuse or unethical conduct</li>
              </ul>

              <h3 style={{ color: "#FF6A00" }}>9. Fees, Taxes & Settlement</h3>
              <ul>
                <li>
                  Retailers are responsible for VAT, income tax, or withholding
                  taxes under Ethiopian law
                </li>
                <li>Ant may deduct or withhold taxes where legally required</li>
              </ul>

              <h3 style={{ color: "#FF6A00" }}>
                10. Data Privacy and Confidentiality
              </h3>
              <ul>
                <li>
                  Ant complies with Ethiopia’s data protection and cybersecurity
                  regulations
                </li>
                <li>
                  User data is securely stored and used only for business and
                  service improvement
                </li>
                <li>Data is shared only with consent or legal obligation</li>
              </ul>

              <h3 style={{ color: "#FF6A00" }}>
                11. Intellectual Property Rights
              </h3>
              <p>
                All software, trademarks, databases, and platform content are
                the property of Ant Technology Plc.
              </p>
              <p>
                Users may not copy, modify, reverse-engineer, or exploit any
                part of the platform without written authorization.
              </p>

              <h3 style={{ color: "#FF6A00" }}>12. Limitation of Liability</h3>
              <ul>
                <li>Indirect or consequential losses</li>
                <li>Service interruptions or third-party failures</li>
                <li>Losses from inaccurate user-provided information</li>
              </ul>
              <p>
                Ant’s total liability shall not exceed the service fees earned
                from the affected transaction.
              </p>

              <h3 style={{ color: "#FF6A00" }}>13. Amendments</h3>
              <p>
                Ant may update these Terms periodically. Continued use of the
                platform constitutes acceptance of revised terms.
              </p>

              <h3 style={{ color: "#FF6A00" }}>
                14. Governing Law & Dispute Resolution
              </h3>
              <ul>
                <li>
                  Disputes shall first be resolved through amicable negotiation
                </li>
                <li>
                  Unresolved disputes within 15 working days shall be referred
                  to arbitration in Addis Ababa under Ethiopian Arbitration Law
                </li>
                <li>
                  These Terms are governed by Ethiopian commercial and digital
                  trade laws
                </li>
              </ul>

              <h3 style={{ color: "#FF6A00" }}>15. Acceptance</h3>
              <p>
                By clicking “Agree” or using Ant’s services, you acknowledge
                that you have read, understood, and accepted these Terms and
                Conditions.
              </p>

              <b>Last updated: March 2025</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
